var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:([_vm.elementStyles, _vm.basicContentStyles])},[_c('div',{style:(_vm.primary_styles),domProps:{"innerHTML":_vm._s(_vm.weekday)}}),_vm._v(" "),_c('div',{style:(_vm.secondary_styles)},[_vm._v(" "+_vm._s(_vm.datestring)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }